import { Link } from 'react-router-dom'
import ROUTES from '../routes'

function NoPage() {
    return (
        <div className="authincation h-100">
            <div className="container h-100">
                <div className="row justify-content-center h-100 align-items-center">
                    <div className="col-md-5">
                        <div className="form-input-content text-center error-page">
                            <h1 className="error-text font-weight-bold">400</h1>
                            <h4><i className="fas fa-thumbs-down text-danger"></i> Bad Request</h4>
                            <p>Your Request resulted in an error</p>
                            <div>
                                <Link to={ROUTES.ROOT} className="btn btn-primary">
                                    Back to Home
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NoPage
